module.exports = __webpack_public_path__ + "static/img/leader4.4075b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leader4.png
// module id = W2Q6
// module chunks = 1